var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgElectricalServices(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 66,
    viewBox: "0 0 75 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.625 41.25C74.625 38.9812 72.7688 37.125 70.5 37.125H62.25V45.375H70.5C72.7688 45.375 74.625 43.5188 74.625 41.25Z",
    fill: "#0F3E5F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5 53.625H62.25V61.875H70.5C72.7688 61.875 74.625 60.0188 74.625 57.75C74.625 55.4812 72.7688 53.625 70.5 53.625Z",
    fill: "#0F3E5F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 41.25H29.25V57.75H37.5C37.5 62.2875 41.2125 66 45.75 66H58.125V33H45.75C41.2125 33 37.5 36.7125 37.5 41.25Z",
    fill: "#0F3E5F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.625 37.125C8.625 32.5875 12.3375 28.875 16.875 28.875H23.0625C31.0238 28.875 37.5 22.3988 37.5 14.4375C37.5 6.47625 31.0238 0 23.0625 0H8.625C6.35625 0 4.5 1.85625 4.5 4.125C4.5 6.39375 6.35625 8.25 8.625 8.25H23.0625C26.4862 8.25 29.25 11.0138 29.25 14.4375C29.25 17.8612 26.4862 20.625 23.0625 20.625H16.875C7.75875 20.625 0.375 28.0087 0.375 37.125C0.375 46.2412 7.75875 53.625 16.875 53.625H25.125V45.375H16.875C12.3375 45.375 8.625 41.6625 8.625 37.125Z",
    fill: "#0F3E5F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricalServices);
export default __webpack_public_path__ + "static/media/electrical_services.044b57d54041dcb0bee61aa323e9623c.svg";
export { ForwardRef as ReactComponent };